export const CHANGE_LANG = 'CHANGE_LANG';
export const SET_LANGS = 'SET_LANGS';



// WEBPACK FOOTER //
// ./src/providers/LanguageProvider/LanguageProvider.constants.js